import {JetView, plugins} from "webix-jet"; // Importing JetView and plugins from webix-jet framework
import PlayersView from "views/players"; // Importing PlayersView component
import {devConfig} from "config/config"; // Importing development configuration

/**
 * CustomersView class extends JetView to create a view for customer management.
 */
export default class CustomersView extends JetView {
	/**
	 * Configures the layout of the CustomersView.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service
		const theme = this.app.config.theme; // Current theme configuration
		webix.ui.fullScreen(); // Set the UI to full screen mode
		return {
			type: "clean", // Clean type for the form
			view:"form", // Form view
			id:"a10", // Unique ID for the form
			scroll: "y", // Enable vertical scrolling
            rows:[{
            	type:"wide", // Wide type for the row
                responsive: "a10", // Responsive design based on ID a10
                margin: 10, // Margin around the row
				id:"a11", // Unique ID for the inner layout
					cols:[
						{
							localId:"inner:layout", gravity:4, type: "wide", rows:[
								{
										view: "toolbar", css: theme, // Toolbar with the current theme
										elements: [
										{width: 30, css:"back-button", view:"button", type:"icon", icon:"wxi-angle-left", id:"security.adminuser", align:"center",
										click:()=> { // Click event to navigate back to players list
												this.show("../playersList");
										}},
										{
											hidden: (!devConfig.getPermAction('editEmailUser', 'Add')), // Oculta el campo si el usuario no tiene permiso para visualizar los correos electronicos.
											css: "user-selected", // Clase CSS aplicada al elemento.
											view: "label", // Tipo de componente (etiqueta de texto).
											id: "lblTittle", // Identificador único del componente.
											align: "center" // Alineación del texto al centro.
										},
										]
								},
								{
									view:"tabbar", localId:"tabbar", // Tab bar for navigation
									height:35, // Height of the tab bar
									options:[
										{ id:"information", value:_("Información"), hidden:!devConfig.getPermAction("customersInformationMenu", "Menu"), css:"prm-customersInformationMenu"}, // Information tab with permission check
										{ id:"customers.financescustomer/customers.financial.informationFinancial", value:_("Finanzas"), hidden:!devConfig.getPermAction("customersFinancialMenu", "Menu"), css:"prm-customersFinancialMenu"}, // Finances tab with permission check
										{ id:"customers.reportscustomer/customers.depositReport", value:_("Reportes"), hidden:!devConfig.getPermAction("customersReportsMenu", "Menu"), css:"prm-customersReportsMenu"}, // Reports tab with permission check
										{ id:"customers.configuration/customers.configuration.securityChanges", value:_("Configuración"), hidden:!devConfig.getPermAction("customersConfigurationMenu", "Menu"), css:"prm-customersConfigurationMenu"}, // Configuration tab with permission check
									]
								},
								{ $subview:true } // Placeholder for subview
							],
						}
					]
					}]
		};
	}

	/**
	 * Initializes the CustomersView.
	 */
	init(){
		this.use(plugins.Menu,this.$$("tabbar")); // Using Menu plugin with tabbar
		const cur_user = this.getParam("user", true); // Get current user parameter
		const _ = this.app.getService("locale")._; // Localization service
		webix.ready(function(){ // Execute when Webix is ready
			if (screen.width > 500){ // Check screen width
				$$("a11").addView({ // Add PlayersView to layout if screen width is sufficient
					minWidth: (screen.width < 500) ? 500 : 257, // Minimum width for the view
					rows:[
						PlayersView // Include PlayersView
					]
				})
			}
		});
		// AJAX request to fetch client data by ID
		webix.ajax().get(devConfig.geturlApi() + "Client/GetClientById", 'id=' + cur_user, {
			error: function (text, data, XmlHttpRequest) { // Error handling for AJAX request
				webix.message("Error! "); // Display error message
			},
			success: function (text, data, XmlHttpRequest) { // Success handling for AJAX request
				data = JSON.parse(text); // Parse the response text
				if (screen.width > 500){ // Check screen width for responsive display
					$$("lblTittle").setValue("<div class='username-active'><span class='icon-user'></span><div style='font-weight: normal'>"+_("Usuario:")+" &nbsp;</div><div>"+data[0].Login+"</div></div>"); // Set title label with user information
				}else{
					$$("lblTittle").setValue("<div>"+data[0].Login+"</div>"); // Set title label with user information for smaller screens
				}
			}
		});
	}
}

// FILE DOCUMENTED
